<template>
    <div v-if="visible" class="content-propec-info-details">
        <div v-for="(layout, layoutIndex) in individualPropecInfo.content" :key="layoutIndex" data-cy="propec-info-container">
            <template v-if="layout.is === 'ImageBlockLayout'">
                <propec-info-image-block-layout contentClass="mb-8 info-dialog-image-block" :layout="layout" data-cy="info-dialog-image-block"></propec-info-image-block-layout>
            </template>

            <template v-if="layout.is === 'VideoBlockLayout'">
                <propec-info-video-block-layout contentClass="mb-8 info-dialog-video-block" :layout="layout" data-cy="info-dialog-video-block"></propec-info-video-block-layout>
            </template>

            <template v-if="layout.is === 'TextLayout'">
                <propec-info-text-layout contentClass="mb-8 info-dialog-text-block" :layout="layout" data-cy="info-dialog-text-block"></propec-info-text-layout>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        visible: Boolean, // Fixes videos still playing in the background after closing the modal
        individualPropecInfo: Object,
    },
};
</script>
